module.exports = __webpack_public_path__ + "img/public/SiteIcons/road.png?60510848";